import { useNavigate } from '@/utils/useNavigate';
import { useEmotionCss } from '@ant-design/use-emotion-css';
import type { MenuProps } from 'antd';
import { Dropdown, Space, Typography, theme } from 'antd';

import { SettingsSvg } from '@/assets/icon';
import { find, isEmpty } from 'lodash-es';
import { memo, useMemo } from 'react';

const { Text } = Typography;
const { useToken } = theme;

export const Settings = memo(({ route, initialState }: any) => {
  const { token } = useToken();
  const navigate = useNavigate();

  const wrapClassName = useEmotionCss(() => {
    return {
      height: '44px',
      lineHeight: '44px',
      color: token.colorTextSecondary,
      cursor: 'pointer',
    };
  });

  const itemWrap = useEmotionCss(() => {
    return {
      margin: '0 4px',
      '&:hover': {
        color: '#000',
      },
    };
  });

  const itemSelected = useEmotionCss(() => {
    return {
      // borderBottom: '4px solid rgba(31, 31, 31, 1) !important',
      color: 'rgb(0, 0, 0) !important',
    };
  });

  const onClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
  };

  const checkAuthorization = (value) => {
    if (!isEmpty(value)) {
      const data = find(initialState?.permissions, (item) => {
        return value?.includes(item.name);
      });
      return data?.name ? true : false;
    }
  };

  const items: any = useMemo(() => {
    const settingRoutes = route?.children?.find((d) => d.path === '/setting');
    return settingRoutes?.children
      ?.filter((d) => !d.hideInSettingMenu && d.access && !!d.name)
      ?.map((d) => {
        if (checkAuthorization(d.access)) {
          return {
            key: d.path,
            label: d.name,
            icon: (
              <img
                style={{ marginLeft: d.icon == 'moban' ? '2px' : 0 }}
                src={require(`./svg/${d.icon}.svg`)?.default}
              ></img>
            ),
          };
        }
      });
  }, [route, initialState]);

  return items?.length ? (
    <div className={wrapClassName}>
      <Dropdown menu={{ items, onClick }}>
        <Space
        // className={classnames(itemWrap, { [itemSelected]: location.pathname.includes('/setting/') })}
        >
          <span style={{ position: 'relative', top: '2px' }}>
            <SettingsSvg />
          </span>
          <span
            style={{
              color: token.colorTextSecondary,
              // [itemSelected]: location.pathname.includes('/setting')
            }}
          >
            设置
          </span>
        </Space>
      </Dropdown>
    </div>
  ) : null;
});
